import React from 'react';
import { LogoBlack } from '../../assets/LogoBlack';
import BouncingLoader from '../BouncingLoader/BouncingLoader';

const AppLoader: React.FC = () => (
	<div className="fixed inset-0 flex flex-col items-center justify-center gap-8 bg-alabaster">
		<LogoBlack />
		<BouncingLoader />
	</div>
);

export default AppLoader;
